<script setup lang="ts">

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'

import { useFiltersDisciplineProgressReports } from '../model/filters-discipline-progress-reports.hook'

defineOptions({
  name: 'FiltersDisciplineProgressReports',
})

const {
  refDueDateRange,
  isLoading,
  search,
  clearFilters,
} = useFiltersDisciplineProgressReports()
</script>

<template>
  <FiltersBar
    class="filters-discipline-progress-reports"
    :loading="isLoading"
    @click:submit="search"
    @click:clear="clearFilters"
  >
    <template #fields>
      <FilterDateRange
        v-model="refDueDateRange"
        presets
        class="filters-discipline-progress-reports__date"
        label="Due date & time"
        placeholder="Search"
        :disabled="isLoading"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersDisciplineProgressReports.scss" />
